var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c(
        "div",
        {
          staticClass: "simple-event-component clearfix",
          attrs: { idfoevent: _vm.event.idfoevent.toString() }
        },
        [
          _vm.isDebug
            ? _c("div", { staticClass: "debug" }, [
                _vm._v("\n    idfoevent " + _vm._s(_vm.event.idfoevent) + " "),
                _c("br"),
                _vm._v(
                  "\n    eventdisplayorder " +
                    _vm._s(_vm.event.eventdisplayorder)
                ),
                _c("br"),
                _vm._v(
                  "\n    eventrows " + _vm._s(_vm.event.eventrows) + "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.event.idfobolifestate === "O"
            ? _c(
                "div",
                { staticClass: "flex-row" },
                [
                  _c("div", { staticClass: "event-info" }, [
                    !_vm.event.isoutright
                      ? _c("div", { staticClass: "info-head" }, [
                          _vm.showheader === undefined || _vm.showheader
                            ? _c(
                                "h2",
                                { staticClass: "sport-name" },
                                [
                                  (_vm.brand_translux4 &&
                                    !_vm.isSportIconAvailableForTranslux4) ||
                                  _vm.brand_translux3 ||
                                  _vm.brand_translux2
                                    ? _c("img", {
                                        staticClass: "logo",
                                        attrs: {
                                          src: "static/img/logo-event.png",
                                          alt: "Logo"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.brand_translux4 &&
                                  _vm.isSportIconAvailableForTranslux4
                                    ? _c("icon", {
                                        attrs: {
                                          name:
                                            "icon-" +
                                            _vm.event.fosporttypename.replace(
                                              / /g,
                                              ""
                                            ),
                                          colorName: "translux4"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.headertype === "DATE"
                                    ? [
                                        _vm.isDateToday
                                          ? [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(_vm.$t("Today")) +
                                                  "\n            "
                                              )
                                            ]
                                          : _vm.isDateTomorrow
                                          ? [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(_vm.$t("Tomorrow")) +
                                                  "\n            "
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(_vm.event.tsDate) +
                                                  "\n            "
                                              )
                                            ]
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.fosporttypename ||
                                              _vm.event.idfosporttype
                                          )
                                        )
                                      ]
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "names-date" }, [
                            _c(
                              "div",
                              {
                                staticClass: "listcode-date",
                                class: {
                                  showparticipantlogo: _vm.teamLogoVisibility
                                }
                              },
                              [
                                !(
                                  _vm.brand_translux4 ||
                                  _vm.brand_translux3 ||
                                  _vm.brand_translux2
                                )
                                  ? _c("span", { staticClass: "listcode" }, [
                                      _vm._v(_vm._s(_vm.listCode.away || "-"))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "time" }, [
                                  _vm.event.idfobolifestate === "O"
                                    ? _c("span", [
                                        _vm.brand_translux4 ||
                                        _vm.brand_translux3 ||
                                        _vm.brand_translux2
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    _vm.event.tsExpectedStart,
                                                    _vm.dateFormats
                                                      .dayAndMonthShort
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isDateToday
                                          ? _c("span", { staticClass: "day" }, [
                                              _vm._v(_vm._s(_vm.$t("Today")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isDateTomorrow
                                          ? _c("span", { staticClass: "day" }, [
                                              _vm._v(_vm._s(_vm.$t("Tomorrow")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isDateToday && !_vm.isDateTomorrow
                                          ? _c("span", { staticClass: "day" }, [
                                              _vm.brand_translux1
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          _vm.event
                                                            .tsExpectedStart,
                                                          _vm.dateFormats
                                                            .dayNameDayAndMonth
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          _vm.event
                                                            .tsExpectedStart,
                                                          _vm.dateFormats
                                                            .dayName
                                                        )
                                                      )
                                                    )
                                                  ])
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "hour" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.event.tsExpectedStart,
                                                _vm.dateFormats.shortTime
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm._f("moment")(
                                                  _vm.event.tsExpectedStart,
                                                  "A"
                                                )
                                              )
                                          )
                                        ])
                                      ])
                                    : _c("span", [
                                        _vm._v(_vm._s(_vm.$t("Finished")))
                                      ])
                                ]),
                                _vm._v(" "),
                                !(
                                  _vm.brand_translux4 ||
                                  _vm.brand_translux3 ||
                                  _vm.brand_translux2
                                )
                                  ? _c("span", { staticClass: "listcode" }, [
                                      _vm._v(_vm._s(_vm.listCode.home || "-"))
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.isSportReverseParticipants
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "names",
                                    class: {
                                      "team-logos": _vm.teamLogoVisibility
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "away" }, [
                                      _vm.showparticipantlogo
                                        ? _c("span", {
                                            staticClass: "team-logo",
                                            style: _vm.awayTeamLogoStyle
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.brand_translux4 ||
                                      _vm.brand_translux3 ||
                                      _vm.brand_translux2
                                        ? _c(
                                            "span",
                                            { staticClass: "listcode" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.listCode.away || "-")
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "team-name-wrapper" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "team-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.event.participantnameaway
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.event.idfosporttype === "BASEBALL"
                                            ? _c(
                                                "span",
                                                { staticClass: "pitcher" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.event
                                                            .awaypitchername
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.showParticipantStats &&
                                                  (_vm.awayParticipantPitcherRecord ||
                                                    _vm.awayParticipantPitcherEra)
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "stats"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.awayParticipantPitcherRecord
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm.awayParticipantPitcherRecord &&
                                                          _vm.awayParticipantPitcherEra
                                                            ? _c("span", [
                                                                _vm._v(", ")
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.awayParticipantPitcherEra
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showParticipantStats &&
                                      _vm.awayParticipantWins &&
                                      _vm.awayParticipantLosses
                                        ? _c("span", { staticClass: "stats" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.awayParticipantWins
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.awayParticipantLosses
                                                ) +
                                                "\n                "
                                            ),
                                            _vm.awayParticipantTies
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.awayParticipantTies
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.awayParticipantOvertimeLosses
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.awayParticipantOvertimeLosses
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "home" }, [
                                      _vm.showparticipantlogo
                                        ? _c("span", {
                                            staticClass: "team-logo",
                                            style: _vm.homeTeamLogoStyle
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.brand_translux4 ||
                                      _vm.brand_translux3 ||
                                      _vm.brand_translux2
                                        ? _c(
                                            "span",
                                            { staticClass: "listcode" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.listCode.home || "-")
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "team-name-wrapper" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "team-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.event.participantnamehome
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.event.idfosporttype === "BASEBALL"
                                            ? _c(
                                                "span",
                                                { staticClass: "pitcher" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.event
                                                            .homepitchername
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.showParticipantStats &&
                                                  (_vm.homeParticipantPitcherRecord ||
                                                    _vm.homeParticipantPitcherEra)
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "stats"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.homeParticipantPitcherRecord
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm.homeParticipantPitcherRecord &&
                                                          _vm.homeParticipantPitcherEra
                                                            ? _c("span", [
                                                                _vm._v(", ")
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.homeParticipantPitcherEra
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showParticipantStats &&
                                      _vm.homeParticipantWins &&
                                      _vm.homeParticipantLosses
                                        ? _c("span", { staticClass: "stats" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.homeParticipantWins
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.homeParticipantLosses
                                                ) +
                                                "\n                "
                                            ),
                                            _vm.homeParticipantTies
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.homeParticipantTies
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.homeParticipantOvertimeLosses
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.homeParticipantOvertimeLosses
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isSportReverseParticipants
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "names",
                                    class: {
                                      "team-logos": _vm.teamLogoVisibility
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "home" }, [
                                      _vm.showparticipantlogo
                                        ? _c("span", {
                                            staticClass: "team-logo",
                                            style: _vm.homeTeamLogoStyle
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.brand_translux4 ||
                                      _vm.brand_translux3 ||
                                      _vm.brand_translux2
                                        ? _c(
                                            "span",
                                            { staticClass: "listcode" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.listCode.home || "-")
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "team-name-wrapper" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "team-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.event.participantnamehome
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.event.idfosporttype === "BASEBALL"
                                            ? _c(
                                                "span",
                                                { staticClass: "pitcher" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.event
                                                            .homepitchername
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.showParticipantStats &&
                                                  (_vm.homeParticipantPitcherRecord ||
                                                    _vm.homeParticipantPitcherEra)
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "stats"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.homeParticipantPitcherRecord
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm.homeParticipantPitcherRecord &&
                                                          _vm.homeParticipantPitcherEra
                                                            ? _c("span", [
                                                                _vm._v(", ")
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.homeParticipantPitcherEra
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showParticipantStats &&
                                      _vm.homeParticipantWins &&
                                      _vm.homeParticipantLosses
                                        ? _c("span", { staticClass: "stats" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.homeParticipantWins
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.homeParticipantLosses
                                                ) +
                                                "\n                "
                                            ),
                                            _vm.homeParticipantTies
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.homeParticipantTies
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.homeParticipantOvertimeLosses
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.homeParticipantOvertimeLosses
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "away" }, [
                                      _vm.showparticipantlogo
                                        ? _c("span", {
                                            staticClass: "team-logo",
                                            style: _vm.awayTeamLogoStyle
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.brand_translux4 ||
                                      _vm.brand_translux3 ||
                                      _vm.brand_translux2
                                        ? _c(
                                            "span",
                                            { staticClass: "listcode" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.listCode.away || "-")
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "team-name-wrapper" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "team-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.event.participantnameaway
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.event.idfosporttype === "BASEBALL"
                                            ? _c(
                                                "span",
                                                { staticClass: "pitcher" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.event
                                                            .awaypitchername
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.showParticipantStats &&
                                                  (_vm.awayParticipantPitcherRecord ||
                                                    _vm.awayParticipantPitcherEra)
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "stats"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.awayParticipantPitcherRecord
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm.awayParticipantPitcherRecord &&
                                                          _vm.awayParticipantPitcherEra
                                                            ? _c("span", [
                                                                _vm._v(", ")
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.awayParticipantPitcherEra
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showParticipantStats &&
                                      _vm.awayParticipantWins &&
                                      _vm.awayParticipantLosses
                                        ? _c("span", { staticClass: "stats" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.awayParticipantWins
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.awayParticipantLosses
                                                ) +
                                                "\n                "
                                            ),
                                            _vm.awayParticipantTies
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.awayParticipantTies
                                                      )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.awayParticipantOvertimeLosses
                                              ? _c("span", [
                                                  _vm._v(
                                                    " - " +
                                                      _vm._s(
                                                        _vm.awayParticipantOvertimeLosses
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.event.isoutright
                      ? _c("div", { staticClass: "info-head" }, [
                          _c(
                            "h2",
                            { staticClass: "sport-name" },
                            [
                              (_vm.brand_translux4 &&
                                !_vm.isSportIconAvailableForTranslux4) ||
                              _vm.brand_translux3 ||
                              _vm.brand_translux2
                                ? _c("img", {
                                    staticClass: "logo",
                                    attrs: {
                                      src: "static/img/logo-event.png",
                                      alt: "Logo"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.brand_translux4 &&
                              _vm.isSportIconAvailableForTranslux4
                                ? _c("icon", {
                                    attrs: {
                                      name:
                                        "icon-" +
                                        _vm.event.fosporttypename.replace(
                                          / /g,
                                          ""
                                        ),
                                      colorName: "translux4"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.event.fosporttypename ||
                                      _vm.event.idfosporttype
                                  ) +
                                  "\n        "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "team-name" }, [
                            _vm._v(_vm._s(_vm.event.eventname))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm.event.idfobolifestate === "O"
                              ? _c("span", [
                                  _vm.isDateToday
                                    ? _c("span", { staticClass: "day" }, [
                                        _vm._v(_vm._s(_vm.$t("Today")))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDateTomorrow
                                    ? _c("span", { staticClass: "day" }, [
                                        _vm._v(_vm._s(_vm.$t("Tomorrow")))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isDateToday && !_vm.isDateTomorrow
                                    ? _c("span", { staticClass: "day" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("moment")(
                                              _vm.event.tsExpectedStart,
                                              _vm.dateFormats.longDate
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "hour" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.event.tsExpectedStart,
                                          _vm.dateFormats.shortTime
                                        )
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.event.tsExpectedStart,
                                            "A"
                                          )
                                        )
                                    )
                                  ])
                                ])
                              : _c("span", [_vm._v(_vm._s(_vm.$t("Finished")))])
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.event.idfobolifestate === "O" &&
                  (_vm.popularMarkets.length > 0 ||
                    _vm.screenConfiguration.is2showeventsin2columns ||
                    _vm.screenConfiguration.is2showsingleevent)
                    ? _c("markets", {
                        staticClass: "markets-container",
                        attrs: {
                          event: _vm.event,
                          markets: _vm.popularMarkets,
                          is2displayhorizontally:
                            _vm.event.is2displayhorizontally,
                          showheader: _vm.showheader
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "expanded-markets",
              class: {
                open:
                  _vm.event.idfobolifestate === "O" &&
                  _vm.expandedMarkets.length > 0
              }
            },
            [
              _vm.event.idfobolifestate === "O" &&
              _vm.expandedMarkets.length > 0
                ? _c("markets", {
                    staticClass: "markets-container",
                    attrs: {
                      event: _vm.event,
                      markets: _vm.expandedMarkets,
                      is2displayhorizontally: _vm.event.is2displayhorizontally
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.event.idfobolifestate !== "O"
            ? _c("div", { staticClass: "event-info" }, [
                _c("div", { staticClass: "info-head" }, [
                  _vm.showheader === undefined || _vm.showheader
                    ? _c(
                        "h2",
                        { staticClass: "sport-name" },
                        [
                          (_vm.brand_translux4 &&
                            !_vm.isSportIconAvailableForTranslux4) ||
                          _vm.brand_translux3 ||
                          _vm.brand_translux2
                            ? _c("img", {
                                staticClass: "logo",
                                attrs: {
                                  src: "static/img/logo-event.png",
                                  alt: "Logo"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand_translux4 &&
                          _vm.isSportIconAvailableForTranslux4
                            ? _c("icon", {
                                attrs: {
                                  name:
                                    "icon-" +
                                    _vm.event.fosporttypename.replace(/ /g, ""),
                                  colorName: "translux4"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.headertype === "DATE"
                            ? [_vm._v(_vm._s(_vm.event.tsDate))]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.event.fosporttypename ||
                                      _vm.event.idfosporttype
                                  )
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "names-date" }, [
                    _c(
                      "div",
                      {
                        staticClass: "listcode-date",
                        class: { showparticipantlogo: _vm.teamLogoVisibility }
                      },
                      [
                        _c("span", { staticClass: "listcode" }, [
                          _vm._v(_vm._s(_vm.listCode.away || "-"))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "time" }, [
                          _vm._v(_vm._s(_vm.$t("Finished")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "listcode" }, [
                          _vm._v(_vm._s(_vm.listCode.home || "-"))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "names",
                        class: { "team-logos": _vm.teamLogoVisibility }
                      },
                      [
                        _c("span", { staticClass: "away" }, [
                          _vm.showparticipantlogo
                            ? _c("span", {
                                staticClass: "team-logo",
                                style: _vm.awayTeamLogoStyle
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "team-name-wrapper" }, [
                            _c("span", { staticClass: "team-name" }, [
                              _vm._v(_vm._s(_vm.event.participantnameaway))
                            ]),
                            _vm._v(" "),
                            _vm.event.idfosporttype === "BASEBALL"
                              ? _c("span", { staticClass: "pitcher" }, [
                                  _vm._v(_vm._s(_vm.event.awaypitchername))
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "home" }, [
                          _vm.showparticipantlogo
                            ? _c("span", {
                                staticClass: "team-logo",
                                style: _vm.homeTeamLogoStyle
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "team-name-wrapper" }, [
                            _c("span", { staticClass: "team-name" }, [
                              _vm._v(_vm._s(_vm.event.participantnamehome))
                            ]),
                            _vm._v(" "),
                            _vm.event.idfosporttype === "BASEBALL"
                              ? _c("span", { staticClass: "pitcher" }, [
                                  _vm._v(_vm._s(_vm.event.homepitchername))
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                !_vm.hideScores
                  ? _c("div", { staticClass: "info" }, [
                      _c("table", [
                        _c("thead", [
                          _vm.showheader === undefined || _vm.showheader
                            ? _c(
                                "tr",
                                [
                                  _c("th", { staticClass: "final-result" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("Results.FSC")) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "SOCCER"
                                    ? _c("th", { staticClass: "halftime" }, [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("Results.HT")) +
                                            "\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "BASKETBALL" ||
                                  _vm.event.idfosporttype === "NFL"
                                    ? [
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber < 5
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        result.periodnumber
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber > 4
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("Results.OT")
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        })
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "ICE HOCKEY"
                                    ? [
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber < 4
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        result.periodnumber
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber === 4
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("Results.OT")
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber === 5
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("Results.SO")
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        })
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "BASEBALL"
                                    ? [
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber < 10
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        result.periodnumber
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.periodResults, function(
                                          result
                                        ) {
                                          return result.periodnumber > 9
                                            ? _c(
                                                "th",
                                                { staticClass: "period" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("Results.OT")
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        })
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "TENNIS"
                                    ? _vm._l(_vm.periodResults, function(
                                        result
                                      ) {
                                        return _c(
                                          "th",
                                          { staticClass: "period" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(result.periodnumber) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("tbody", [
                          _c(
                            "tr",
                            { staticClass: "away" },
                            [
                              _c("td", { staticClass: "match score" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.finalResult &&
                                        _vm.finalResult.awayscoreline
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.event.idfosporttype === "SOCCER"
                                ? _c(
                                    "td",
                                    { staticClass: "score halftimescore" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.soccerHTResult &&
                                              _vm.soccerHTResult.awayscoreline
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.periodResults, function(result) {
                                return _vm.event.idfosporttype !== "SOCCER"
                                  ? _c("td", { staticClass: "score" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(result.awayscoreline) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e()
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            { staticClass: "home" },
                            [
                              _c("td", { staticClass: "match score" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.finalResult &&
                                        _vm.finalResult.homescoreline
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.event.idfosporttype === "SOCCER"
                                ? _c("td", { staticClass: "score" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.soccerHTResult &&
                                            _vm.soccerHTResult.homescoreline
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.periodResults, function(result) {
                                return _vm.event.idfosporttype !== "SOCCER"
                                  ? _c("td", { staticClass: "score" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(result.homescoreline) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6236674", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6236674","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/simpleEvent.vue
// module id = null
// module chunks = 